import { combineReducers } from "redux";
import product from "./product";

const formsReducer = combineReducers({
  product,
});

export default formsReducer;
